import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
  Transition
} from '@headlessui/react';
import React, { useEffect, useRef, useState } from 'react';
import StyledImage from '../StyledImage';
import Image from 'next/image';
import closeimg from '../../public/img/close-icn.svg';
import { IProduct } from '../../models';
import { useTranslation } from 'react-i18next';
import placeholder from '../../public/img/placeholder.svg';
import { scrollToId } from '../../helpers/scroller';
import { PopupSection } from './ProductOverviews';
import { classNames } from '../../helpers/classes';

export default function StickyPopup({
  product,
  price,
  image,
  show,
  section,
  setSection
}: {
  product: IProduct;
  price: string;
  image: string;
  show: boolean;
  section: PopupSection | undefined;
  setSection: any;
}) {
  const { t } = useTranslation();
  const buttonRef = useRef<any>();
  const [sectionOpen, setSectionOpen] = useState<boolean>(false);
  const { ContentComponent } = section || {};

  const { extreme, productName } = product;

  useEffect(() => {
    setTimeout(() => {
      if (section && buttonRef.current && !sectionOpen) {
        buttonRef.current.click();
      }
    }, 250);
  }, [section]);

  return (
    <Transition
      as="div"
      show={show}
      enter="transition-opacity duration-150"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      {ContentComponent && (
        <div
          className="fixed top-0 left-0 right-0 bottom-0 bg-gray-900 z-20 opacity-20"
          onClick={() => setSection(null)}
        ></div>
      )}
      <div id="sticky-popup">
        <div className="sm:w-full w-11/12 mx-auto sm:mx-0 sm:max-w-md p-2 bg-white rounded-md fixed bottom-8 right-0 left-0 sm:left-auto sm:transform sm:right-1/2 sm:translate-x-2/4 z-20 shadow-xl">
          <Disclosure>
            {({ open, close }: { open: boolean; close: any }) => {
              setSectionOpen(open);
              return (
                <>
                  {section && (
                    <DisclosurePanel className="px-4 pt-4 pb-2 text-sm opacity-60 border-b border-gray-200 max-h-80 overflow-y-auto sm:max-h-96">
                      <button
                        className="text-center bg-white text-primary rounded-full w-8 h-8 flex justify-center items-center absolute right-0 -top-10"
                        onClick={e => {
                          close(e);
                          setSection(null);
                        }}
                      >
                        <StyledImage
                          src={closeimg}
                          className="h-4"
                          alt="close icon"
                        />
                      </button>
                      {ContentComponent && <ContentComponent />}
                    </DisclosurePanel>
                  )}
                  <DisclosureButton
                    ref={buttonRef}
                    onClick={(e: any) => {
                      e.stopPropagation();
                    }}
                    className="flex items-center justify-between w-full px-2 py-2 text-sm font-bold text-left rounded-lg focus:outline-none focus-visible:ring focus-visible:ring-purple-500 focus-visible:ring-opacity-75"
                  >
                    <div className="flex items-center">
                      <div className="w-16">
                        {image ? (
                          <Image
                            src={image}
                            alt={productName}
                            width={80}
                            height={80}
                          />
                        ) : (
                          <StyledImage src={placeholder} alt={productName} />
                        )}
                      </div>
                      <div className="ml-2">
                        <h5 className="opacity-60 mb-1 text-xs sm:text-sm">
                          {productName}
                        </h5>
                        <p className="text-xs sm:text-sm">{price}</p>
                      </div>
                    </div>
                    <div className="ml-2 border-l-2 border-modalgrey pl-4">
                      <div
                        className={classNames(
                          extreme ? 'bg-orange' : 'bg-primary',
                          'text-center text-black px-3 py-3 rounded-md text-xs sm:text-sm'
                        )}
                        onClick={e => {
                          e.stopPropagation();
                          close();
                          setSection(null);
                          scrollToId('product-add-to-cart');
                        }}
                      >
                        {t('BUY')}
                      </div>
                    </div>
                  </DisclosureButton>
                </>
              );
            }}
          </Disclosure>
        </div>
      </div>
    </Transition>
  );
}
